import { ElementColors } from "@/common/theme/ElementColors";
import { PPStatusData } from "@/picking-portal/models/PPStatusData";

export enum PPOrderStatus {
  SUBMITTED = "SUBMITTED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

const prefix = "modules.packing-portal.order.status.";

export const PPOrderStatusMap: Map<PPOrderStatus, PPStatusData> = new Map<PPOrderStatus, PPStatusData>([
  [PPOrderStatus.SUBMITTED, { text: `${prefix}submitted`, color: ElementColors.Chip.Submitted }],
  [PPOrderStatus.CANCELLED, { text: `${prefix}cancelled`, color: ElementColors.Chip.Cancelled }],
]);
